import { all } from 'redux-saga/effects';
import { watchApp } from './app.sagas';
import { watchCart } from './cart.sagas';
import { watchCategories } from './category.sagas';
import { watchProducts } from './product.sagas';
import { watchUsers } from './user.sagas';

export default function* rootSaga() {
  yield all([
    watchApp(),
    watchCart(),
    watchCategories(),
    watchProducts(),
    watchUsers(),
  ]);
}
